// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
var intercalate = /* #__PURE__ */ Data_Array.intercalate(Data_Monoid.monoidString);
var todo = function (msg) {
    var header = Data_String_CodeUnits.fromCharArray(Data_Array.replicate(20)("="));
    return Partial_Unsafe.unsafeCrashWith(intercalate("\x0a")([ header, "[TODO]", msg, header ]));
};
var fromJust = function (msg) {
    return function (v) {
        if (v instanceof Data_Maybe.Nothing) {
            return Partial_Unsafe.unsafeCrashWith("[unsafe] fromJust Nothing: " + msg);
        };
        if (v instanceof Data_Maybe.Just) {
            return v.value0;
        };
        throw new Error("Failed pattern match at Unsafe (line 17, column 16 - line 19, column 14): " + [ v.constructor.name ]);
    };
};
export {
    todo,
    fromJust
};
